import { render, staticRenderFns } from "./IbDialogConfirmationContent.vue?vue&type=template&id=f6f32a28&scoped=true"
import script from "./IbDialogConfirmationContent.vue?vue&type=script&lang=js"
export * from "./IbDialogConfirmationContent.vue?vue&type=script&lang=js"
import style0 from "./IbDialogConfirmationContent.vue?vue&type=style&index=0&id=f6f32a28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f32a28",
  null
  
)

export default component.exports